import img1 from "../../assets/Images/Reports/Expense Report.png"

export default function ExpenseReport() {
  return (
    <section id="expense-report" className="space-y-16">
      <section className="bg-white rounded-xl border border-slate-200 p-10">
        <h1 className="text-2xl font-bold text-slate-900 mb-2">
          3. Expense Report
        </h1>
        <p className="text-md text-slate-600 max-w-3xl">
          The Expense Report provides a clear overview of all operational expenses
          recorded in the system within a selected date range.
        </p>


        {/* OVERVIEW */}
        <section className="bg-white border-l border-[#C9A24E] p-4 mt-2">
          <h2 className="text-lg font-semibold mb-3">
            Overview
          </h2>
          <p className="text-slate-600 text-sm">
            This report is primarily used by accounts and management teams to track
            outgoing expenses, monitor spending patterns, and ensure financial
            discipline across banquet operations.

          </p>
        </section>
      </section>


      {/* FILTERS */}
      <section className="">
        <div>
          <h3 className="font-semibold mb-2">
            Expense Date Filter
          </h3>
          <p className="text-slate-600 mb-3">
            The Expense Report is filtered using the expense date, allowing users
            to review costs incurred during a specific period.
          </p>

          <ul className="list-disc pl-5 text-slate-600 space-y-1">
            <li>Select Start Date and End Date</li>
            <li>Filter applies only to expense entries</li>
            <li>Helps analyze daily, monthly, or custom periods</li>
          </ul>
        </div>
      </section>

      {/* TABLE */}
      <section className="bg-white border border-slate-200 rounded-xl p-8">
        <h3 className="font-semibold mb-3">
          Expense Report Table
        </h3>

        <p className="text-slate-600 mb-4">
          The table displays all expense records matching the selected date range.
          Each row represents a single expense entry.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Expense Account (category)</li>
          <li>Expense Amount</li>
          <li>Expense Date</li>
          <li>Description or notes</li>
        </ul>

        <div className=" rounded-lg p-4 mt-4">
          <img src={img1} alt="" />
        </div>
      </section>

      {/* TOTAL */}
      <section className="bg-slate-100 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Total Expense Calculation
        </h3>

        <p className="text-slate-600">
          At the bottom of the table, EventFlow automatically calculates the total
          expense amount for the selected period, helping users quickly assess
          overall spending.
        </p>
      </section>

      {/* SEARCH */}
      <section className="bg-white border border-slate-200 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Search Within Expenses
        </h3>

        <p className="text-slate-600 mb-3">
          The search box allows users to quickly find specific expense records.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Search by expense account name</li>
          <li>Search by description keywords</li>
          <li>Helpful when managing large expense volumes</li>
        </ul>
      </section>

      {/* EXPORT */}
      <section className="bg-[#C9A24E]/10 rounded-xl p-8">
        <h3 className="font-semibold mb-2">
          Exporting Expense Reports
        </h3>

        <p className="text-slate-600 mb-3">
          The Expense Report can be exported for offline review and record keeping.
        </p>

        <ul className="list-disc pl-5 text-slate-600 space-y-1">
          <li>Export report to Excel format</li>
          <li>Download printable PDF version</li>
          <li>Useful for audits and financial reviews</li>
        </ul>
      </section>

    </section>
  );
}
